module.exports = __webpack_public_path__ + "a252c0655751fa3ac9db5fc84f9967a0.svg";